import { render } from "./Heading.vue?vue&type=template&id=76582d8d"
import script from "./Heading.vue?vue&type=script&setup=true&lang=js"
export * from "./Heading.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Elements/Section/Heading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76582d8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76582d8d', __exports__)) {
    api.reload('76582d8d', __exports__)
  }
  
  module.hot.accept("./Heading.vue?vue&type=template&id=76582d8d", () => {
    api.rerender('76582d8d', render)
  })

}


export default __exports__